module.exports = __webpack_public_path__ + "8e492fb98927cc7c61285cf41b814921.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/night_15.jpg
// module id = 1765
// module chunks = 5